/**
 * Auth-only saved address helper for the local delivery cart form.
 * Reads compact Shopify customer address data rendered into the page and
 * lets the shopper manually fill recipient fields without extra network calls.
 */
(function () {
  'use strict';

  function normalizeText(value) {
    return String(value || '').trim();
  }

  function parseSavedAddresses(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      var addresses = [];
      for (var i = 0; i < parsed.length; i++) {
        var item = parsed[i];
        if (!item || typeof item !== 'object') continue;
        var countryCode = normalizeText(item.countryCode).toUpperCase();
        var country = normalizeText(item.country).toLowerCase();
        if (countryCode && countryCode !== 'SG' && country !== 'singapore') continue;
        var normalized = {
          id: normalizeText(item.id),
          label: normalizeText(item.label),
          firstName: normalizeText(item.firstName),
          lastName: normalizeText(item.lastName),
          phone: normalizeText(item.phone),
          address1: normalizeText(item.address1),
          address2: normalizeText(item.address2),
          zip: normalizeText(item.zip),
          city: normalizeText(item.city),
          country: normalizeText(item.country),
          countryCode: countryCode,
          isDefault: !!item.isDefault,
        };
        if (!normalized.id || !normalized.address1 || !normalized.zip) continue;
        addresses.push(normalized);
      }
      addresses.sort(function (a, b) {
        if (a.isDefault === b.isDefault) return 0;
        return a.isDefault ? -1 : 1;
      });
      return addresses;
    } catch (err) {
      console.warn('[wf-ld-saved-addresses] Failed to parse saved addresses', err);
      return [];
    }
  }

  function buildOptionLabel(address) {
    if (address.label) return address.label;
    var parts = [];
    var name = [address.firstName, address.lastName].join(' ').trim();
    if (name) parts.push(name);
    if (address.address1) parts.push(address.address1);
    if (address.zip) parts.push(address.zip);
    return parts.join(' • ');
  }

  function createInitResult(state, addresses, dispose) {
    return {
      state: state,
      getState: function () { return state; },
      getAddresses: function () { return addresses.slice(); },
      dispose: dispose || function () {},
    };
  }

  function clearOptions(select) {
    if (!select) return;
    if (typeof select.innerHTML === 'string') {
      select.innerHTML = '';
    }
    if (Array.isArray(select.options)) {
      select.options.length = 0;
    }
  }

  function appendOption(documentRef, select, value, text) {
    if (!documentRef || !select || typeof documentRef.createElement !== 'function') return;
    var option = documentRef.createElement('option');
    option.value = value;
    option.textContent = text;
    if (typeof select.appendChild === 'function') select.appendChild(option);
  }

  function createSavedAddressController(ctx) {
    ctx = ctx || {};
    var documentRef = ctx.document || document;
    var block = ctx.block || documentRef.getElementById('wf-ld-saved-address-block');
    var select = ctx.select || documentRef.getElementById('wf-ld-saved-address-select');
    var dataEl = ctx.dataEl || documentRef.getElementById('wf-ld-saved-addresses-data');
    var actions = ctx.actions || {};
    var state = {
      hasSavedAddresses: false,
      selectedSavedAddressId: '',
    };

    if (!block || !select || !dataEl) return createInitResult(state, []);

    var addresses = parseSavedAddresses(dataEl.textContent || '');
    if (!addresses.length) {
      block.style.display = 'none';
      return createInitResult(state, []);
    }

    clearOptions(select);
    appendOption(documentRef, select, '', block.getAttribute('data-placeholder') || 'Use saved address');
    for (var i = 0; i < addresses.length; i++) {
      appendOption(documentRef, select, addresses[i].id, buildOptionLabel(addresses[i]));
    }

    state.hasSavedAddresses = true;
    block.style.display = '';

    function handleChange() {
      var selectedId = normalizeText(select.value);
      state.selectedSavedAddressId = selectedId;
      if (!selectedId || typeof actions.applySavedAddress !== 'function') return;
      for (var i = 0; i < addresses.length; i++) {
        if (addresses[i].id === selectedId) {
          actions.applySavedAddress(addresses[i]);
          return;
        }
      }
    }

    if (typeof select.addEventListener === 'function') {
      select.addEventListener('change', handleChange);
    }

    return createInitResult(state, addresses, function () {
      if (typeof select.removeEventListener === 'function') {
        select.removeEventListener('change', handleChange);
      }
    });
  }

  window.WF_LD_SAVED_ADDRESSES = {
    createSavedAddressController: createSavedAddressController,
  };
})();
